<template>
    <div>
        <!--<div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >品名/批次号:</span>
            <el-input
                    size="mini"
                    class="mr10"
                    placeholder="品名或批次号 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'" size="mini">搜索</el-button>
        </div>-->
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="i_pzid"
                height="220"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="false"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_num_ky"
                    :label="$t('purchaseOrder_contract_available_quantity')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    :label="$t('form_metering')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
            <el-button type="primary" @click="saveForm" class="btn" size="small" :disabled="disabled">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ProductDetails",
        props:{
            productDetails:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                i_htid:0,
                /****************/
                cpinput:"",
                multipleSelection:[],
                detailsData:[],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                disabled:false,
                selected:[],
                relRecvCompany:'',
                i_source:0,
            }

        },
        watch:{
            productDetails:{
                handler(){
                    if (this.productDetails){
                        // console.log(this.productDetails,"watch");
                        this.i_htid=this.productDetails.i_htid;
                        this.relRecvCompany=this.productDetails.relRecvCompany;
                        this.i_source=this.productDetails.i_source;
                        this.getPzListByHtid();

                    }
                },
                immediate:true,
                deep:true
            }

        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.productDetails,"mounted");
            //this.mid=this.productDetails.i_mid;
            //this.selected=this.productDetails.selected;
            /*this.ckid=this.productDetails.i_ckid;
            this.gsid_out=this.productDetails.i_gsid_out;
             this.i_pzid=this.productDetails.i_pzid;*/
            //this.getWarehousingProductList();
        },
        methods: {
            //列表
            async getPzListByHtid(){
                let param={
                   i_htid:this.i_htid,
                    relRecvCompany:this.relRecvCompany,
                    i_source:this.i_source,
                };
                let res=await API.getPzListByHtid(param);
                if(res.code==1){
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data;
                    if (this.selected){
                        if (this.detailsData.length>0&&this.selected.length>0) {
                            this.selected.forEach(row => {
                                this.$refs.multipleTable.toggleRowSelection(row);
                            });
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            searchData(){
                this.detailsData=[];
                /*this.pageSize=1;
                this.currentPage=1;*/
                this.getWarehousingProductList();
            },
            cancel(){
                this.$emit('closePop');
            },

            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                //console.log(val)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
            saveForm(){
                this.disabled=true;
                /*//过滤合同可用量为0
                let choosedata = this.multipleSelection.filter((item)=>{
                    return item.f_num_ky!=0
                })
                this.$emit('transValue',choosedata);*/
                //不控0924
                this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },
            pageCurrentChange(val){
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                this.getWarehousingProductList();
            },
        },
    }
</script>

<style lang="scss" scoped>
.searchName{
    width: 100px; display: inline-block;vertical-align: middle;text-align: center;
}
    .mr10{
        width: 50%;
    }

.btn{
    background-color: var(--light);
    border: var(--light);
}

/deep/{
    .danger-row{
        color: #999;
    }
}
</style>